const PhraseEvent = {
  // phrase events
  translationsCreate: 'translations:create',
  translationsUpdate: 'translations:update',
  keysCreate: 'keys:create',
  // internal events
  cmsUpload: 'cms:upload'
};
module.exports = PhraseEvent;